import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "../../lib/api";

export default function CategoryShowcase() {
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data || [])).catch(() => {});
  }, []);

  return (
    <section className="section-pad" data-testid="category-showcase">
      <div className="container-site">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <p className="accent-script text-gold text-2xl mb-1">Kategoriler</p>
            <h2 className="heading-serif text-3xl md:text-4xl font-semibold text-navy">
              Otelinize Özel Ekipman Dünyası
            </h2>
            <p className="text-gray-600 mt-2 max-w-xl">
              Buklet ürünlerinden restoran servis takımlarına — uzman seçimimizle kürate edilmiş kategoriler.
            </p>
          </div>
          <Link to="/kategoriler" className="text-navy hover:text-gold flex items-center gap-1 link-underline" data-testid="category-showcase-all">
            Tüm Kategoriler <ArrowUpRight size={14} />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {cats.map((c, i) => (
            <Link
              key={c.id}
              to={`/kategori/${c.slug}`}
              className="relative group aspect-[4/3] rounded-xl overflow-hidden"
              data-testid={`category-card-${c.slug}`}
            >
              {c.image && (
                <img
                  src={c.image}
                  alt={c.name}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading={i < 3 ? "eager" : "lazy"}
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-navy/95 via-navy/40 to-transparent" />
              <div className="absolute inset-0 p-5 flex flex-col justify-end text-white">
                <h3 className="heading-serif text-xl font-semibold">{c.name}</h3>
                <p className="text-xs text-white/70 mt-1 line-clamp-2">{c.description}</p>
                <span className="inline-flex items-center gap-1 text-gold text-xs mt-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  Ürünleri Keşfet <ArrowUpRight size={12} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
